
export const endpoint = {
  date: 'date'
};
